import { Dispatch, SetStateAction } from 'react';
import Avatar from '../../../../juristec-ui/core/Avatar';
import IconButton from '../../../../juristec-ui/core/IconButton';
import Tooltip from '../../../../juristec-ui/core/Tooltip';
import Select from '../../../../juristec-ui/core/SelectNew';
import { Close } from '../../../../juristec-ui/icons';
import { SelectOption } from '../../../../types';
import {
  MainContainer, UsersContainer, UserItem, UserInfoText,
} from './styled';

interface UsersSharedProps {
  users: SelectOption[];
  sharedState: [SelectOption[], Dispatch<SetStateAction<SelectOption[]>>];
  markDirty: () => void;
}

const UsersShared = ({
  users,
  sharedState,
  markDirty,
}: UsersSharedProps) => {
  const [shared, setShared] = sharedState;
  const handleShared = (selected: SelectOption[]) => {
    markDirty();
    setShared(selected);
  };

  const removeShared = (key: string) => {
    markDirty();
    setShared((srd) => srd.filter((s) => s.value !== key));
  };

  return (
    <MainContainer>
      <Select
        label="Usuários"
        searchable
        options={users}
        // @ts-expect-error not typed yet
        value={shared}
        onChange={handleShared}
        multiple
        fullWidth
        atModal
        stayOpen
      />
      <UsersContainer>
        {!!shared && shared.length > 0 && shared.map(((user) => (
          <UserItem key={user.value}>
            <Avatar name={user.name} src={user.photoUrl || null} size="medium" />
            <UserInfoText>
              <h4>{user.name}</h4>
              <span className="email">{user.email}</span>
              <span>{user.roleLabel}</span>
            </UserInfoText>
            <Tooltip text="Remover" atModal className="user-group-item-remove">
              <IconButton
                onClick={() => removeShared(user.value)}
              >
                <Close />
              </IconButton>
            </Tooltip>
          </UserItem>
        )))}
      </UsersContainer>
    </MainContainer>
  );
};

export default UsersShared;
